<template>
  <div class="h-100" style="min-height: 100%">
    <router-view />
  </div>
</template>

<script>
export default {};
</script>
